



































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import type { ProjectUser } from '@/models/projectUser';
import type { PMPhase } from '@/models/pmphase';
import type { Company } from '@/models/company';

@Component({
    name: 'PmToDosFilters',
    components: {},
})
export default class PmToDosFilters extends Vue {
    private selectedResponsibleUsers: ProjectUser[] = [];
    private selectedPmPhases: PMPhase[] = [];

    @Getter('project/selectedProject') private selectedProject: Project;
    @Prop() private isDesktop: boolean;
    @Prop() private errors: string[];

    @Getter('utils/currentLocale') private currentLocale: string;
    @Getter('account/company') private company: Company;

    @Watch('selectedProject')
    private onSelectedProjectChange() {
        this.selectedResponsibleUsers = this.allProjectUsers;
        this.$emit('update:selected-responsible-users', this.selectedResponsibleUsers);

        if (this.selectedProject.pmphases.length > 0) {
            this.selectedPmPhases = this.selectedProject.pmphases;
            this.$emit('update:selected-pm-phases', this.selectedPmPhases);
        }
    }

    private checkError(errorKey: string) {
        return this.errors.includes(errorKey);
    }

    private fullname({ firstname, lastname }) {
        return `${firstname} ${lastname}`;
    }

    private get allProjectUsers() {
        const projectUsers: ProjectUser[] = [];
        this.selectedProject.users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: false,
            };
            projectUsers.push(temp);
        });
        this.selectedProject.external_users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: true,
            };
            projectUsers.push(temp);
        });

        return projectUsers;
    }
}
